import { CwtProp, CwtSchema } from "@cawita/core-front/api";

@CwtSchema()
export class Sizes {
    @CwtProp() pants: number;
    @CwtProp() shoes: number;
}